import { Group, Skeleton, Stack } from '@mantine/core';

export const ActivityItemSkeleton = () => {
  return (
    <Group align="start" mt="space6">
      <Skeleton height={40} circle />
      <Stack flex={1} gap={4}>
        <Skeleton height={20} width={100} />
        <Skeleton height={14} width={60} />
        <Skeleton height={18} width="70%" />
      </Stack>
    </Group>
  );
};
